export class ChatAndMeetModel {
  chatId: string;
  senderId: string;
  receiverId: string;
  message: string;
  attachment: any;
  
   constructor() {
    this.chatId="";
      this.senderId="";
      this.receiverId="";
      this.message="";
      this.attachment=null;
  }
}
